import JsonResource from "@/types/interfaces/JsonResource";

export interface IContractDetails {
  price_per_night: number | null;
  option_type_ids: number[];
}

interface IExtendReservationData {
  reservation_id: string;
  new_departure_date: string;
  contract_details: Record<string, IContractDetails>;
  contract_ids: string[];
}

export default class ExtendReservationData implements JsonResource {
  public reservation_id: string;
  public new_departure_date: string;
  public contract_details: Record<string, IContractDetails>;
  public contract_ids: string[];

  constructor(data: IExtendReservationData) {
    this.reservation_id = data.reservation_id;
    this.new_departure_date = data.new_departure_date;
    this.contract_ids = data.contract_ids;
    this.contract_details = {};

    data.contract_ids.forEach(contractId => {
      const details = data.contract_details[contractId];
      this.contract_details[contractId] = {
        price_per_night: details?.price_per_night ?? null,
        option_type_ids: details?.option_type_ids.map(Number) || []
      };
    });
  }

  toJsonObject(): Record<string, unknown> {
    return {
      reservation_id: this.reservation_id,
      new_departure_date: this.new_departure_date,
      contract_details: this.contract_details,
      contract_ids: this.contract_ids
    };
  }

  toJsonString(): string {
    return JSON.stringify(this.toJsonObject());
  }
}

